module.exports = "/images/pin-route.png?49cdb65f972da18f94fde1357c18a798";